import React from "react";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
export default function ButtonLink(props) {
  return (
    <Link to={props.url} style={{ textDecoration: "none" }}>
      {props.color === "primary" ? (
        <Button variant="contained" color="primary">
          {props.title}
        </Button>
      ) : (
        <Button variant="outlined">{props.title}</Button>
      )}
    </Link>
  );
}
